import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { environment } from '../../../../environments/environment';
import { currentLang } from './keycloak-locale';

@Injectable({
  providedIn: 'root',
})
export class KeycloakInitService {
  constructor(private keycloak: KeycloakService) {}

  initializeKeycloak(): () => Promise<boolean> {
    return () =>
      this.init().catch((error) => {
        // Un APP_INITIALIZER qui rejette annule le bootstrap : l'utilisateur
        // n'obtient qu'une page blanche et une trace illisible. On préfère
        // démarrer non authentifié — les gardes de route renverront alors
        // vers Keycloak, et la cause reste lisible en console.
        console.error(
          '[Keycloak] Initialisation impossible : démarrage en session anonyme.',
          error,
        );
        return false;
      });
  }

  private init(): Promise<boolean> {
    return this.keycloak.init({
      config: {
        url: environment.keycloak.url,
        realm: environment.keycloak.realm,
        clientId: environment.keycloak.clientId,
      },
      initOptions: {
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri:
          window.location.origin + '/assets/silent-check-sso.html',
        pkceMethod: 'S256',
        // Ne couvre que la redirection automatique de `login-required` ;
        // les appels explicites à `login()` passent par `withCurrentLocale`.
        locale: currentLang(),
      },
      enableBearerInterceptor: true,
      // Surtout pas `true` : cela appellerait l'API Account de Keycloak
      // (`/realms/{realm}/account`) au démarrage. Cet appel est soumis au
      // CORS et échoue dès que l'origine n'est pas déclarée côté realm —
      // or l'échec d'un APP_INITIALIZER empêche l'application de démarrer,
      // écran blanc à la clé. Le jeton porte déjà les mêmes informations
      // (voir `AuthService.getUser`), l'appel n'apportait rien.
      loadUserProfileAtStartUp: false,
      bearerPrefix: 'Bearer',
    });
  }
}
